(() => {
  const root = document.querySelector('[data-nuvora-tank]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('#nuvora-tank-data').textContent);
  const variants = data.variants;
  const tiers = [...root.querySelectorAll('.bb-tier')];
  const atc = root.querySelector('#bb-atc-btn');
  const alert = root.querySelector('.nt-error');
  const money = cents => {
    const value = new Intl.NumberFormat('en-AU', { style: 'currency', currency: data.currency || 'AUD' }).format(cents / 100);
    return data.currency === 'AUD' ? value.replace(/^\$/, 'A$') : value;
  };
  const first = variants.find(v => v.available) || variants[0];
  const giftBox = root.querySelector('.mgbrief');
  const giftCheck = giftBox?.querySelector('.mgbrief__chk');
  const giftButton = giftBox?.querySelector('.mgbrief__add');
  function updateGift(tier) {
    if (!giftBox) return;
    const eligible = Number(tier.dataset.qty) >= 3;
    giftBox.hidden = !eligible;
    if (eligible) tier.querySelector('.bb-tier-selectors').append(giftBox);
  }
  if (giftButton) {
    giftBox.querySelector('.mgbrief__top').addEventListener('click', event => event.preventDefault());
    giftButton.addEventListener('click', event => {
      event.preventDefault(); event.stopPropagation();
      giftCheck.checked = !giftCheck.checked;
      giftButton.classList.toggle('is-added', giftCheck.checked);giftBox.classList.toggle('is-on',giftCheck.checked);giftBox.classList.remove('is-pop');void giftBox.offsetWidth;giftBox.classList.add('is-pop');setTimeout(()=>giftBox.classList.remove('is-pop'),700);
      giftButton.querySelector('.mgbrief__addtxt').textContent = giftCheck.checked ? 'ADDED' : 'ADD';
      giftButton.querySelector('.mgbrief__plus').textContent = giftCheck.checked ? '✓' : '+';
      giftButton.setAttribute('aria-pressed', String(giftCheck.checked));
    });
  }
  const selected = row => variants.find(v => v.options.every((o, i) => o === row.querySelector(`[data-option-index="${i}"]`).value));
  const showError = message => { alert.textContent = message; alert.hidden = !message; };
  function refreshRow(row) {
    const colour = row.querySelector('[data-option-index="0"]');
    const size = row.querySelector('[data-option-index="1"]');
    [...colour.options].forEach(o => { o.disabled = /out of stock/i.test(o.value) || !variants.some(v => v.available && v.options[0] === o.value); });
    [...size.options].forEach(o => { o.disabled = !!o.value && !variants.some(v => v.available && v.options[0] === colour.value && v.options[1] === o.value); });
    if (size.selectedOptions[0]?.disabled) size.value = '';
    const v = selected(row) || variants.find(v => v.available && v.options[0] === colour.value);
    if (v?.image) row.querySelector('[data-variant-img]').src = v.image;
  }
  function refreshPrices() {
    tiers.forEach(tier => {
      const rows = [...tier.querySelectorAll('.bb-row')];
      const prices = rows.map(row => (selected(row) || variants.find(v => v.available && v.options[0] === row.querySelector('[data-option-index="0"]').value) || first).price);
      const full = prices.reduce((sum, p) => sum + p, 0);
      const free = Number(tier.dataset.qty) - Number(tier.dataset.paidQty);
      const discount = [...prices].sort((a, b) => a - b).slice(0, free).reduce((sum, p) => sum + p, 0);
      tier.querySelector('.bb-sale-price').textContent = money(full - discount);
      tier.querySelector('.bb-full-price').textContent = free ? money(full) : '';
    });
  }
  tiers.forEach(tier => {
    const header = tier.querySelector('.bb-tier-header');
    header.setAttribute('role', 'button'); header.tabIndex = 0;
    const activate = () => {
      tiers.forEach(t => { const active = t === tier; t.classList.toggle('active', active); t.querySelector('.bb-tier-header').setAttribute('aria-pressed', String(active)); });
      updateGift(tier); showError(''); refreshPrices();
    };
    header.addEventListener('click', activate);
    header.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); } });
    tier.querySelectorAll('.bb-row').forEach(row => {
      row.querySelector('[data-option-index="0"]').value = first.options[0];
      refreshRow(row);
      row.querySelectorAll('select').forEach(select => select.addEventListener('change', () => { refreshRow(row); refreshPrices(); showError(''); }));
    });
  });
  updateGift(tiers.find(t => t.classList.contains('active')));
  refreshPrices();
  atc.addEventListener('click', async () => {
    const tier = tiers.find(t => t.classList.contains('active'));
    const rows = [...tier.querySelectorAll('.bb-row')];
    const chosen = rows.map(selected);
    if (chosen.some(v => !v?.available)) {
      showError('Please choose an available colour and size for every tank.');
      const missing = rows.find(row => !selected(row)?.available);
      missing?.querySelector('[data-option-index="1"]').focus();
      return;
    }
    const quantities = new Map(); chosen.forEach(v => quantities.set(v.id, (quantities.get(v.id) || 0) + 1));
    const items = [...quantities].map(([id, quantity]) => ({ id, quantity }));
    if (giftCheck?.checked && Number(tier.dataset.qty) >= 3) {
      const firstTank = chosen[0];
      const gift = data.giftVariants.find(v => v.available && v.options[0] === firstTank.options[0] && v.options[1] === firstTank.options[1]) || data.giftVariants.find(v => v.available && v.options[0] === 'Nude' && v.options[1] === firstTank.options[1]);
      if (!gift) { showError('The free underwear is unavailable in this size. Please choose another size or remove the gift.'); return; }
      items.push({ id: gift.id, quantity: 1, properties: { _nuvora_tank_gift: 'true' } });
    }
    atc.disabled = true; atc.textContent = 'ADDING…'; showError('');
    try {
      if (!window.NuvoraCart) throw new Error('The cart is still loading. Please try again.');
      await window.NuvoraCart.add(items);
    } catch (e) { showError(e.message || 'Could not add your tanks. Please try again.'); }
    finally { atc.disabled = false; atc.textContent = 'ADD TO CART'; }
  });
  const mainImage = root.querySelector('[id^="MainProductImage"]');
  root.querySelectorAll('[data-tank-thumb]').forEach(thumb => {
    const switchImage = () => { const image = thumb.querySelector('img'); if (!image || !mainImage) return; mainImage.src = image.src.replace(/([?&])width=\d+/g, '$1width=1200'); mainImage.removeAttribute('srcset'); root.querySelectorAll('[data-tank-thumb]').forEach(t => t.classList.toggle('is-active', t === thumb)); };
    thumb.addEventListener('click', switchImage); thumb.addEventListener('keydown', e => { if (e.key === 'Enter') switchImage(); });
  });
  const accordion = root.querySelector('.size-chart-accordion');
  const panel = root.querySelector('.size-chart-accordion__panel');
  root.querySelectorAll('[data-tank-size-toggle]').forEach(button => button.addEventListener('click', () => {
    const open = !accordion.classList.contains('is-open'); accordion.classList.toggle('is-open', open); panel.hidden = !open;
    root.querySelectorAll('[data-tank-size-toggle]').forEach(b => b.setAttribute('aria-expanded', String(open)));
  }));
  document.addEventListener('mt:size-answer', event => {
    const tier = tiers.find(t => t.classList.contains('active'));
    tier.querySelectorAll('[data-option-index="1"]').forEach(select => {
      if ([...select.options].some(o => o.value === event.detail.size && !o.disabled)) select.value = event.detail.size;
    });
    tier.querySelectorAll('.bb-row').forEach(refreshRow); refreshPrices();
  });
  const swatchColours = {Nude:'#f1dbb6',Coffee:'#6f4e37',Black:'#111111',Khaki:'#b0a17e','Red Wine':'#6c2337','Blush Pink':'#e9bbc6',Grey:'#888888',White:'#ffffff','Pastel Pink':'#f2cedb','Pastel Yellow':'#f3e9a8','Pastel Purple':'#cdbde1','Pastel Blue':'#bfd4e8','Navy Blue':'#172b4d'};
  const lists = [];
  root.querySelectorAll('.igsw-wrap').forEach(wrap => {
    const select = wrap.querySelector('select');
    const button = wrap.querySelector('.igsw-btn');
    if (!select || !button) return;
    const list = document.createElement('div'); list.className = 'igsw-list'; list.hidden = true; list.setAttribute('role','listbox'); wrap.append(list); lists.push({list,button});
    const closeLists = () => lists.forEach(x => {x.list.hidden = true;x.button.setAttribute('aria-expanded','false')});
    const colour = value => swatchColours[value.split(' (')[0]] || '#dddddd';
    const sync = () => { button.querySelector('.igsw-txt').textContent = select.selectedOptions[0]?.textContent || ''; button.querySelector('.igsw-dot').style.background = colour(select.value); };
    button.addEventListener('click', () => {
      const open = list.hidden; closeLists(); if(!open)return;
      list.replaceChildren();
      [...select.options].forEach(option => {
        const opt = document.createElement('div'); opt.className = 'igsw-opt'; opt.setAttribute('role','option'); opt.tabIndex=0; opt.classList.toggle('igsw-sel', option.value===select.value); opt.classList.toggle('igsw-off',option.disabled); opt.setAttribute('aria-disabled',String(option.disabled));
        const dot = document.createElement('span'); dot.className='igsw-dot'; dot.style.background=colour(option.value); const label=document.createElement('span');label.textContent=option.textContent;opt.append(dot,label);
        const choose = () => { if(option.disabled)return;select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));sync();closeLists();button.focus() };
        opt.addEventListener('click',choose);opt.addEventListener('keydown',e=>{if(e.key==='Enter')choose()});list.append(opt);
      });list.hidden=false;button.setAttribute('aria-expanded','true');
    });select.addEventListener('change',sync);sync();
  });
  document.addEventListener('click',e=>{if(!e.target.closest('.igsw-wrap'))lists.forEach(x=>{x.list.hidden=true;x.button.setAttribute('aria-expanded','false')})});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')lists.forEach(x=>{x.list.hidden=true;x.button.setAttribute('aria-expanded','false')})});
  const viralCards = [...root.querySelectorAll('.mgt-vrs__card')];
  viralCards.forEach(card => {
    const video = card.querySelector('video');
    const mp4 = video.querySelector('source[type="video/mp4"]')?.src;
    if (mp4) video.dataset.mp4 = mp4;
    video.preload = 'none';
    video.playsInline = true;
    card.setAttribute('role', 'button');
    card.tabIndex = 0;
    const name = card.querySelector('.mgt-vrs__name').textContent;
    card.setAttribute('aria-label', 'Play ' + name + ' video');
    const restore = () => {
      card.classList.remove('is-playing', 'is-loading');
      card.setAttribute('aria-busy', 'false');
    };
    video.addEventListener('playing', () => {
      card.classList.add('is-playing');
      card.classList.remove('is-loading');
      card.setAttribute('aria-busy', 'false');
    });
    video.addEventListener('pause', restore);
    video.addEventListener('ended', restore);
    video.addEventListener('error', () => { restore(); video.controls = true; });
    const play = async () => {
      if (card.classList.contains('is-loading')) return;
      if (!video.paused) { video.pause(); restore(); return; }
      root.querySelectorAll('video').forEach(other => {
        if (other !== video) { other.pause(); other.closest('.mgt-vrs__card')?.classList.remove('is-playing'); }
      });
      if (video.dataset.mp4 && video.getAttribute('src') !== video.dataset.mp4) {
        video.src = video.dataset.mp4;
        video.load();
      }
      card.classList.add('is-loading');
      card.setAttribute('aria-busy', 'true');
      video.controls = true;
      try { await video.play(); }
      catch { restore(); }
    };
    card.addEventListener('click', event => {
      if (event.target === video && video.controls) {
        const rect = video.getBoundingClientRect();
        if (!video.paused || (rect.height > 0 && event.clientY >= rect.bottom - 56)) return;
      }
      play();
    });
    card.addEventListener('keydown', event => {
      if (event.target !== card) return;
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); play(); }
    });
  });
  const track = root.querySelector('.mgt-vrs__grid');
  if (track && viralCards.length) {
    // The capture includes five copies, but not the source's scroll position.
    const count = new Set(viralCards.map(card => card.dataset.name)).size;
    const middle = Math.floor(viralCards.length / count / 2) * count;
    let current = middle + Math.min(1, count - 1);
    let lastWidth = 0;
    let settle;
    const centre = index => {
      const card = viralCards[index];
      return card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
    };
    const jump = index => {
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = centre(index);
      requestAnimationFrame(() => {
        track.style.removeProperty('scroll-snap-type');
        track.style.removeProperty('scroll-behavior');
      });
    };
    const initialise = () => {
      if (!track.clientWidth || !viralCards[current].offsetWidth) return;
      if (track.clientWidth !== lastWidth) {
        lastWidth = track.clientWidth;
        jump(current);
      }
    };
    requestAnimationFrame(initialise);
    window.addEventListener('load', initialise, { once: true });
    if (window.ResizeObserver) new ResizeObserver(initialise).observe(track);
    else window.addEventListener('resize', initialise);
    track.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => {
        current = viralCards.reduce((nearest, card, index) =>
          Math.abs(centre(index) - track.scrollLeft) < Math.abs(centre(nearest) - track.scrollLeft) ? index : nearest, 0);
        if (current < count || current >= viralCards.length - count) {
          current = middle + current % count;
          jump(current);
        }
      }, 180);
    }, { passive: true });
    root.querySelectorAll('.mgt-vrs__btn').forEach(button => button.addEventListener('click', () => {
      const step = Math.abs(centre(middle + 1) - centre(middle));
      track.scrollBy({ left: button.classList.contains('mgt-vrs__btn--prev') ? -step : step, behavior: 'smooth' });
    }));
  }
  root.querySelectorAll('.mag-vrev__play').forEach(button => button.addEventListener('click', async () => {
    const card = button.closest('.mag-vrev__card'), video = card.querySelector('video');
    video.src ||= card.dataset.src; card.classList.add('is-playing');
    root.querySelectorAll('video').forEach(v => { if (v !== video) v.pause(); });
    try { await video.play(); } catch { video.controls = true; }
  }));
})();


(function () {
  var root = document.querySelector('.nuvora-tank-page #shopify-section-template--21406356373675__product_hero_43r8WJ .sf');
  if (!root) return;

  // Staart van de "Choose <maat> ..." regel. De PDP zegt "below when you pick
  // your colours" omdat de kleurkiezer er vlak onder staat; een losse pagina
  // heeft die niet.
  var PICK_TAIL = "below when you pick your colours.";

  var MEASURE_IMG = 'https://cdn.shopify.com/s/files/1/0767/9354/4875/files/maggies-how-to-measure-bust.png?width=800';

  /* ===== LADDERS, 1-op-1 uit de officiele maattabellen ===== */

  var SIZES = ['S','M','L','XL','2XL','3XL','4XL'];

  // Recommended Full Bust in inches:
  // S 32-34 | M 34-36 | L 36-38 | XL 38-40 | 2XL 40-42.5 | 3XL 42.5-44.5 | 4XL 44.5+
  // Op een grens gaat ze OMHOOG, want niemand gaat omlaag. 34 inch is dus M.
  //
  // 17-09-2026: de twee bovenste grenzen een halve inch later, 42 -> 42.5 en
  // 44 -> 44.5. Klanten typen bijna altijd een hele inch: van de klagers tussen
  // 42 en 42,4 inch typte 88 van de 89 precies "42". Die kregen 3XL en zeiden
  // 27x te groot tegen 5x te klein, terwijl 2XL bij dezelfde buste 6x te groot
  // en 8x te klein was. Bij 44 inch net zo: 4XL 8x te groot en 0x te klein,
  // 3XL 24x te groot en 11x te klein. S t/m 2XL zijn niet aangeraakt.
  var BUST = [34, 36, 38, 40, 42.5, 44.5];

  // Het lengte-gewicht raster, 1-op-1 uit de officiele maattabel.
  //
  // De tabel is in kilo's opgezet: 40 45 50 55 60 65 70 75 80 85 90 95 100 kg.
  // Deze grenzen liggen op de KOLOMMEN, niet op het midden ertussen. Ze blijft
  // dus in de kleinere maat tot ze de volgende kolom echt haalt.
  //   5'9" 117 lb -> S   (op de middengrenzen kwam daar M uit, dat was te groot)
  // Zo geeft elke kolom van de tabel exact terug wat er gedrukt staat, in de
  // korte rijen en in de rijen vanaf 5'10".
  //
  // 27-08 stonden deze grenzen even op [105, 120, 130, 140, 160, 185]. Dat was
  // een poging om een bustegeval op te lossen via het GEWICHT: een vrouw van
  // 5'5" en 145 lb met een buste van 40 inch hoort 2XL te hebben. Maar daardoor
  // kreeg iedereen van 143 lb een 2XL, ook met een buste van 36 inch. De buste
  // hoort dat te doen en doet het hieronder al: een ingevulde buste duwt de maat
  // alleen OMHOOG, nooit omlaag. Raster = basis, buste = ophoging. Niet allebei.
  //
  // 17-09-2026: S/M van 120 naar 115 lb en M/L van 142 naar 138 lb. S, M en L
  // vielen in elke periode te klein: van de klagers ruilde 100% van S, 96% van
  // M en 83% van L naar een GROTERE maat. Deze twee grenzen zijn de kleinste
  // stap die in beide meetperiodes beter uitkwam en vrijwel niemand schaadde.
  var WEIGHT = [115, 138, 154, 176, 198, 220];

  // Vanaf 5 voet 10 schuift het raster een maat op, maar alleen tot en met XL.
  // Vanaf 177 lb staat in beide rijen hetzelfde.
  var TALL_IN = 70, TALL_MAX_IDX = 3;

  // 4XL ligt sinds 28-08-2026 op voorraad en is koopbaar op de PDP, dus de
  // rekenhulp mag hem gewoon adviseren. MAX_BUYABLE is de hoogste index in SIZES.
  var MAX_BUYABLE = 6;

  function fromBust(inch) {
    var i = 0; while (i < BUST.length && inch >= BUST[i]) i++;
    return i;
  }
  function fromHW(inch, lb) {
    var i = 0; while (i < WEIGHT.length && lb > WEIGHT[i]) i++;
    if (inch >= TALL_IN && i <= TALL_MAX_IDX) i++;
    return i;
  }

  var sel     = root.querySelector('[data-sf-height]');
  var weightEl= root.querySelector('[data-sf-weight]');
  var bustEl  = root.querySelector('[data-sf-bust]');
  var resultEl= root.querySelector('[data-sf-result]');
  var sizeEl  = root.querySelector('[data-sf-size]');
  var noteEl  = root.querySelector('[data-sf-note]');
  var pickEl  = root.querySelector('[data-sf-pick]');
  var footEl  = root.querySelector('[data-sf-foot]');

  // Metric height choices preserve the original recommendation thresholds.
  sel.innerHTML = '<option value="" disabled selected>Select</option>';
  for (var i = 132; i <= 193; i++) {
    var o = document.createElement('option');
    o.value = i;
    o.textContent = i + ' cm';
    sel.appendChild(o);
  }

  // De meetplaat wordt PAS gebouwd bij de eerste keer openen. Een img met
  // loading="lazy" werkt hier niet: dit blok staat dicht, dus het plaatje heeft
  // hoogte 0 en komt nooit "in beeld", dus laadt lazy hem nooit. En zonder lazy
  // haalt elke bezoeker 664 kB op die de maatzoeker niet eens opent.
  var howBtn = root.querySelector('[data-sf-how]');
  var howPanel = root.querySelector('[data-sf-howpanel]');
  var imgDone = false;
  howBtn.addEventListener('click', function () {
    var open = howPanel.hidden;
    howPanel.hidden = !open;
    howBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    howBtn.textContent = open ? 'Hide how to measure' : 'See how to measure your full bust';
    if (open && !imgDone) {
      imgDone = true;
      var im = document.createElement('img');
      im.className = 'sf__howimg';
      im.width = 1402;  // echte verhouding, reserveert de ruimte alvast
      im.height = 1122;
      im.alt = 'How to measure your bust';
      im.src = MEASURE_IMG;
      howPanel.insertBefore(im, howPanel.firstChild);
    }
  });

  // Zij typt inches OF centimeters, en we rekenen zelf uit welke van de twee.
  // Onder de 70 is het inches (een tankbuste loopt van ongeveer 32 tot 46 inch),
  // vanaf 70 is het centimeters (81 tot 117 cm). Die grens scheidt schoon: een
  // buste van 70 cm bestaat praktisch niet en 70 inch net zomin.
  //
  // Dit is 27-08 gemeld door Jong. Daarvoor gooide het veld alles boven de 70
  // stil weg, dus wie 101 invulde kreeg zonder enige melding gewoon het antwoord
  // van lengte-en-gewicht. Stil negeren mag nooit: als we haar invoer niet
  // kunnen lezen, zeggen we dat.
  function readBust(v) {
    if (!(v > 0)) return null;                                   // leeg, overslaan
    
    if (v >= 70 && v <= 180) return { inch: v / 2.54, cm: v };
    return 'unreadable';                                          // ingevuld maar onmogelijk
  }

  root.querySelector('[data-sf-go]').addEventListener('click', function () {
    var hh = +sel.value / 2.54;
    var kg = Number(weightEl.value.replace(',', '.'));
    var ww = kg / 0.45359237;

    if (!hh || !(kg >= 20 && kg <= 250)) {
      sizeEl.textContent = '—';
      noteEl.textContent = 'Choose your height in cm and enter your weight in kg (20–250) to see your size.';
      pickEl.textContent = '';
      resultEl.hidden = false;
      return;
    }

    var bust = readBust(parseFloat(bustEl.value));
    if (bust === 'unreadable') {
      sizeEl.textContent = '—';
      noteEl.textContent = 'That bust measurement does not look right. Enter centimetres (about 81 to 117), or leave it empty.';
      pickEl.textContent = '';
      resultEl.hidden = false;
      return;
    }

    var hwIdx = fromHW(hh, ww);
    var idx = hwIdx, usedBust = false, shown = '';

    // De BUSTE DUWT ALLEEN OMHOOG, nooit omlaag (Reber 17-09-2026). Zegt haar
    // buste een kleinere maat dan lengte en gewicht, dan houdt ze de maat van
    // het raster: haar lijf wordt niet smaller van een kleine buste. Een vrouw
    // van 5'5" en 165 lb met 34 inch buste kreeg hiervoor M en krijgt nu XL.
    // In de tickets kochten 7 vrouwen die door hun buste omlaag waren gezet die
    // kleinere maat, en alle 7 zeiden "te klein".
    // Vult ze de buste NIET in, dan blijft het lengte-gewicht raster de basis.
    if (bust) {
      usedBust = true;
      shown = (Math.round(bust.cm * 10) / 10) + ' cm';
      idx = Math.max(hwIdx, fromBust(bust.inch));
    }

    var over = idx > MAX_BUYABLE;
    if (over) idx = MAX_BUYABLE;
    var s = SIZES[idx];

    var note;
    // We tonen altijd terug wat we van haar buste gemaakt hebben, in beide
    // eenheden. Zo ziet ze meteen of we haar 101 als centimeters gelezen hebben
    // en niet als inches.
    if (usedBust && idx > hwIdx) {
      note = 'Sized up for your ' + shown + ' bust. That needs more room than your height and weight alone would suggest.';
    } else if (usedBust) {
      note = 'Based on your height, weight and your ' + shown + ' bust.';
    } else {
      note = 'Based on your height and weight.';
    }

    sizeEl.textContent = s;
    noteEl.textContent = note;
    pickEl.textContent = 'Choose ' + s + ' ' + PICK_TAIL;
    // De vangnetregel onder het antwoord is 29-08-2026 weggehaald op verzoek
    // van Reber. De check blijft staan voor als het element ooit terugkomt.
    if (footEl) footEl.hidden = usedBust;
    resultEl.hidden = false;

    document.dispatchEvent(new CustomEvent('mt:size-answer', {
      detail: { size: s, kind: over ? 'max' : 'exact' }
    }));

    // 22-09-2026 (Reber): de antwoorden gaan mee op de order, als cart attributes.
    // De underscore houdt ze uit het zicht van de klant in cart en checkout. Het
    // gewicht bewaren we per 5 lb en de buste per halve inch, geen exact gewicht.
    // Terugkijken: node size-finder-answers.cjs (leest note_attributes van de orders).
    // Mislukt dit, dan merkt de klant niets: het antwoord staat al op het scherm.
    try {
      var wBand = Math.floor(kg / 2) * 2;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          _sf_height: sel.value + ' cm',
          _sf_weight: wBand + '-' + (wBand + 1.9) + ' kg',
          _sf_bust: bust ? (Math.round(bust.cm * 2) / 2) + ' cm' : 'not given',
          _sf_size: s,
          _sf_hw_size: SIZES[Math.min(hwIdx, MAX_BUYABLE)],
          _sf_bust_up: (usedBust && idx > hwIdx) ? 'yes' : 'no'
        } })
      }).catch(function () {});
    } catch (e) {}
  });
})();
